import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("my_tasks.table_assignment"))),
      ]),
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [
          _c(
            "template",
            { slot: "description" },
            [
              _c(VBreadcrumbs, {
                staticClass: "pa-0",
                attrs: { items: _vm.getBreadcrumbs },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.onEnableFilter },
                },
                [
                  _vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-off-outline"),
                      ])
                    : _vm._e(),
                  !_vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter"),
                      ])
                    : _vm._e(),
                  _vm._v(_vm._s(_vm.$t("btns.filter"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm.filter_enabled
        ? _c(
            VCard,
            { staticClass: "d-block d-md-none mb-2" },
            [
              _c(VCardTitle, { staticClass: "pointer" }, [
                _vm._v(_vm._s(_vm.$t("my_tasks.search_filters"))),
              ]),
              _c(
                VCardText,
                { staticClass: "pa-2" },
                [
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      !_vm.isEmptyTable
                        ? _c("search-in-table-new", {
                            ref: "search",
                            attrs: { showDomains: false },
                            on: { submit: _vm.sendToSearch },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(VRow, [
        _c(
          "div",
          { class: _vm.getClassTable },
          [
            _vm.tablas.length == 0
              ? _c("StateComponent", {
                  attrs: {
                    state: "empty_state",
                    title: _vm.$t("my_tasks.no_objects"),
                    subtitle: _vm.$t("my_tasks.no_objects_subtitle"),
                  },
                })
              : _c(
                  VCard,
                  [
                    _vm.isSynapse
                      ? _c(VDataTable, {
                          key: "table_synapse_" + _vm.key_table_synapse,
                          staticClass: "table-inca",
                          attrs: {
                            headers: _vm.headers,
                            items: _vm.tablas,
                            "hide-default-footer": true,
                            page: _vm.pagination_synapse.current,
                          },
                          on: {
                            "update:page": function ($event) {
                              return _vm.$set(
                                _vm.pagination_synapse,
                                "current",
                                $event
                              )
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "item.tableReference.tableId",
                                fn: function (row) {
                                  return [
                                    _c("div", { staticClass: "text-left" }, [
                                      _c("b", { staticClass: "table-name" }, [
                                        _c(
                                          "a",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.openEditTpl(row.item)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                row.item.tableReference.tableId
                                              )
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _c("br"),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "compose-name",
                                          attrs: { title: row.item.id },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("joinTableReference")(
                                                row.item.tableReference
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "item.creationTime",
                                fn: function (row) {
                                  return [
                                    _c("a", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatDate")(
                                            row.item.creationTime
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "item.actions",
                                fn: function (row) {
                                  return [
                                    !_vm.isProdTable(row.item)
                                      ? _c(
                                          VTooltip,
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function (ref) {
                                                    var on = ref.on
                                                    var attrs = ref.attrs
                                                    return [
                                                      _c(
                                                        VBtn,
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              staticClass:
                                                                "btn-icon-inca",
                                                              attrs: {
                                                                icon: "",
                                                                small: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.openEditTpl(
                                                                      row.item
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            "v-btn",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c(VIcon, [
                                                            _vm._v(
                                                              "icon-user_add"
                                                            ),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("my_tasks.assign")
                                                )
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.isProdTable(row.item)
                                      ? _c(
                                          VTooltip,
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function (ref) {
                                                    var on = ref.on
                                                    var attrs = ref.attrs
                                                    return [
                                                      _c(
                                                        VBtn,
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              staticClass:
                                                                "btn-icon-inca",
                                                              attrs: {
                                                                icon: "",
                                                                small: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.openViewTpl(
                                                                      row.item
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            "v-btn",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c(VIcon, [
                                                            _vm._v("icon-view"),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.$t("frases.view"))
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.userHasPermission
                                      ? _c(
                                          VTooltip,
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function (ref) {
                                                    var on = ref.on
                                                    var attrs = ref.attrs
                                                    return [
                                                      _c(
                                                        VBtn,
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              staticClass:
                                                                "btn-icon-inca",
                                                              attrs: {
                                                                icon: "",
                                                                small: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.asyncTableWithSchema(
                                                                      row.item
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            "v-btn",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c(VIcon, [
                                                            _vm._v(
                                                              "icon-renew"
                                                            ),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.$t("my_tasks.sync"))
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "item.numRows",
                                fn: function (row) {
                                  return [
                                    _c("span", { staticClass: "date-format" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatNumber")(
                                            row.item.numRows
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1413881598
                          ),
                        })
                      : _vm._e(),
                    !_vm.isSynapse
                      ? _c(VDataTable, {
                          key: "table_bigquery_" + _vm.key_table,
                          staticClass: "table-inca",
                          attrs: {
                            headers: _vm.headers,
                            items: _vm.tablas,
                            "hide-default-footer": "",
                            "disable-pagination": "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "item.tableReference.tableId",
                                fn: function (row) {
                                  return [
                                    _c("div", { staticClass: "text-left" }, [
                                      _c("b", { staticClass: "table-name" }, [
                                        _c(
                                          "a",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.openEditTpl(row.item)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                row.item.tableReference.tableId
                                              )
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _c("br"),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "compose-name",
                                          attrs: { title: row.item.id },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("joinTableReference")(
                                                row.item.tableReference
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "item.creationTime",
                                fn: function (row) {
                                  return [
                                    _c("a", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatDate")(
                                            row.item.creationTime
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "item.actions",
                                fn: function (row) {
                                  return [
                                    _c(
                                      VTooltip,
                                      {
                                        attrs: { bottom: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function (ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    VBtn,
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          staticClass:
                                                            "btn-icon-inca",
                                                          attrs: {
                                                            icon: "",
                                                            small: "",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.openEditTpl(
                                                                row.item
                                                              )
                                                            },
                                                          },
                                                        },
                                                        "v-btn",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c(VIcon, [
                                                        _vm._v("icon-user_add"),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("my_tasks.assign"))
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm.userHasPermission
                                      ? _c(
                                          VTooltip,
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function (ref) {
                                                    var on = ref.on
                                                    var attrs = ref.attrs
                                                    return [
                                                      _c(
                                                        VBtn,
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              staticClass:
                                                                "btn-icon-inca",
                                                              attrs: {
                                                                icon: "",
                                                                small: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.asyncTableWithSchema(
                                                                      row.item
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            "v-btn",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c(VIcon, [
                                                            _vm._v(
                                                              "icon-renew"
                                                            ),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.$t("my_tasks.sync"))
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "item.numRows",
                                fn: function (row) {
                                  return [
                                    _c("span", { staticClass: "date-format" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatNumber")(
                                            row.item.numRows
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            840167232
                          ),
                        })
                      : _vm._e(),
                  ],
                  1
                ),
            _vm.isSynapse
              ? _c("pagination-vue", {
                  key: "pag_synapse_" + _vm.key_pagination_synapse,
                  attrs: { pagination: _vm.pagination_synapse },
                  on: { onInput: _vm.changePaginaSynapse },
                })
              : _vm._e(),
            !_vm.isSynapse
              ? _c("pagination-catalog", {
                  key: "pag_bigquery_" + _vm.key_pagination,
                  attrs: { pagination: _vm.pagination },
                  on: { changePagina: _vm.changePagina },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm.filter_enabled
          ? _c(
              "div",
              { staticClass: "col-md-3 d-none d-md-block pl-0" },
              [
                _c(
                  VCard,
                  { staticClass: "filters-inca" },
                  [
                    _c(
                      VCardTitle,
                      {
                        staticClass: "pointer",
                        on: {
                          click: function ($event) {
                            _vm.collapse_filter = !_vm.collapse_filter
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("my_tasks.search_filters")))]
                    ),
                    _c(
                      VCardText,
                      { staticClass: "pa-2 pt-0" },
                      [
                        !_vm.isEmptyTable
                          ? _c("search-in-table-new", {
                              ref: "searchr",
                              attrs: {
                                showDomains: false,
                                showSynapse: _vm.isSynapseActive,
                              },
                              on: { submit: _vm.sendToSearch },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c(
        "DialogsComponent",
        {
          ref: _vm.DIALOG_ASSIGN,
          attrs: { title: _vm.texts.assign, width: 1200 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-metadata", {
                ref: _vm.DIALOG_ASSIGN + "_body",
                attrs: {
                  tplToWork: _vm.tplToUpdate,
                  isChangeRequest: _vm.TYPE_CHANGE_METADA.OWENER_FLOW,
                  source: _vm.source,
                  isSynapse: _vm.isSynapse,
                },
                on: {
                  submit: _vm.assignOwner,
                  cancel: function ($event) {
                    return _vm.$refs[_vm.DIALOG_ASSIGN].onClose()
                  },
                },
              }),
            ],
            1
          ),
          _vm.tplToUpdate.tipo == "edicion" &&
          _vm.TYPE_CHANGE_METADA.OWENER_FLOW !=
            _vm.TYPE_CHANGE_METADA.VIEWER_ONLY
            ? _c(
                "template",
                { slot: "btnsRight" },
                [
                  _vm.TYPE_CHANGE_METADA.OWENER_FLOW ==
                  _vm.TYPE_CHANGE_METADA.PREVIEW_OWNER
                    ? _c(
                        VBtn,
                        {
                          attrs: { type: "submit" },
                          on: {
                            click: function ($event) {
                              _vm.$refs[
                                _vm.DIALOG_ASSIGN + "_body"
                              ].validateForm("refuse")
                            },
                          },
                        },
                        [
                          _c(VIcon, { staticClass: "md-16" }, [
                            _vm._v("icon-remove"),
                          ]),
                          _vm._v(_vm._s(_vm.$t("btns.reject"))),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.$refs[_vm.DIALOG_ASSIGN + "_body"].validateForm(
                            "ok"
                          )
                        },
                      },
                    },
                    [
                      _vm.TYPE_CHANGE_METADA.OWENER_FLOW ==
                      _vm.TYPE_CHANGE_METADA.CHANGE_REQUEST
                        ? _c(
                            "span",
                            [
                              _c(VIcon, { staticClass: "md-16" }, [
                                _vm._v("icon-send"),
                              ]),
                              _vm._v(_vm._s(_vm.$t("btns.request"))),
                            ],
                            1
                          )
                        : _c(
                            "span",
                            [
                              _c(VIcon, { staticClass: "md-16" }, [
                                _vm._v("icon-send"),
                              ]),
                              _vm._v(_vm._s(_vm.$t("btns.accept"))),
                            ],
                            1
                          ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "template",
            { slot: "btnsLeft" },
            [
              _vm.showSplitMetadataDownload
                ? [
                    _c(
                      VBtn,
                      {
                        attrs: { outlined: "", color: "primary", dense: "" },
                        on: {
                          click: function ($event) {
                            _vm.$refs[
                              _vm.DIALOG_ASSIGN + "_body"
                            ].downloadTableMetadataTemplate()
                          },
                        },
                      },
                      [
                        _c(VIcon, [_vm._v("icon-download")]),
                        _vm._v(_vm._s(_vm.$t("my_tasks.tables_metadata"))),
                      ],
                      1
                    ),
                    _c(
                      VBtn,
                      {
                        staticClass: "ml-1",
                        attrs: { outlined: "", color: "primary", dense: "" },
                        on: {
                          click: function ($event) {
                            _vm.$refs[
                              _vm.DIALOG_ASSIGN + "_body"
                            ].downloadColumnMetadataTemplate()
                          },
                        },
                      },
                      [
                        _c(VIcon, [_vm._v("icon-download")]),
                        _vm._v(_vm._s(_vm.$t("my_tasks.columns_metadata"))),
                      ],
                      1
                    ),
                  ]
                : _c(
                    VBtn,
                    {
                      attrs: { outlined: "", color: "primary", dense: "" },
                      on: {
                        click: function ($event) {
                          _vm.$refs[
                            _vm.DIALOG_ASSIGN + "_body"
                          ].clickDownloadCSV()
                        },
                      },
                    },
                    [
                      _c(VIcon, [_vm._v("icon-download")]),
                      _vm._v(_vm._s(_vm.$t("btns.download_metadata"))),
                    ],
                    1
                  ),
            ],
            2
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: "MODAL_NAME_METADATA_VIEW",
          attrs: { title: "Metadata Table Detail", width: 1800 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-metadata-table-component", {
                key: "key_view_" + _vm.key_view,
                ref: "viewmetadataTableRef",
                attrs: {
                  tplToWork: _vm.objToRequest,
                  isChangeRequest: _vm.TYPE_CHANGE_METADA.VIEWER_ONLY,
                },
                on: {
                  submit: function ($event) {
                    return _vm.$refs["MODAL_NAME_METADATA_VIEW"].onClose()
                  },
                  cancel: function ($event) {
                    return _vm.$refs["MODAL_NAME_METADATA_VIEW"].oncClose()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsLeft" },
            [
              _vm.showSplitMetadataDownload
                ? [
                    _c(
                      VBtn,
                      {
                        attrs: { color: "secondary", outlined: "" },
                        on: {
                          click: function ($event) {
                            return _vm.$refs.viewmetadataTableRef.downloadTableMetadataTemplate()
                          },
                        },
                      },
                      [
                        _c(VIcon, { attrs: { small: "" } }, [
                          _vm._v("icon-download"),
                        ]),
                        _vm._v(_vm._s(_vm.$t("my_tasks.tables_metadata"))),
                      ],
                      1
                    ),
                    _c(
                      VBtn,
                      {
                        staticClass: "ml-1",
                        attrs: { color: "secondary", outlined: "" },
                        on: {
                          click: function ($event) {
                            return _vm.$refs.viewmetadataTableRef.downloadColumnMetadataTemplate()
                          },
                        },
                      },
                      [
                        _c(VIcon, { attrs: { small: "" } }, [
                          _vm._v("icon-download"),
                        ]),
                        _vm._v(_vm._s(_vm.$t("my_tasks.columns_metadata"))),
                      ],
                      1
                    ),
                  ]
                : _c(
                    VBtn,
                    {
                      attrs: { color: "secondary", outlined: "" },
                      on: {
                        click: function ($event) {
                          return _vm.$refs.viewmetadataTableRef.clickDownloadCSV()
                        },
                      },
                    },
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("icon-download"),
                      ]),
                      _vm._v(_vm._s(_vm.$t("botones.boton_download_metadata"))),
                    ],
                    1
                  ),
            ],
            2
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }